<div class="flex items-center gap-4">
    <span class="text-bold">Package Name: </span>
    <span>{{ patientPackageDetails?.package_name }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Duration: </span>
    <span>
        {{ patientPackageDetails?.package_duration 
            ? patientPackageDetails?.package_duration + ' ' + (patientPackageDetails?.package_duration === 1 ? 'Day' : 'Days') 
            : 0 }}
      </span>
      
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Psychiatrist Name: </span>
    <span>{{ getPractitionerName(patientPackageDetails?.patient_rpp_psychiatrist_assignment) || 'N/A' }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Psychologist Name: </span>
    <span>{{ getPractitionerName(patientPackageDetails?.patient_rpp_psychologist_assignment) || 'N/A' }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Counsellor Name: </span>
    <span>{{ getPractitionerName(patientPackageDetails?.patient_rpp_counsellor_assignment) || 'N/A' }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">CRT: </span>
    <span>{{ patientPackageDetails?.need_crt || 'N/A' }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Provisional Diagnosisand: </span>
    <span>{{ patientPackageDetails?.provisionaldiagnosisandcode || 'N/A' }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Other Provisional Diagnosisand: </span>
    <span>{{ patientPackageDetails?.otherprovisionaldiagnosisandcode || 'N/A' }}</span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Enrollment Date: </span>
    <span>{{ patientPackageDetails?.enrollment_date }} </span>
</div>
<div class="flex items-center gap-4">
    <span class="text-bold">Due Date: </span>
    <span>{{ patientPackageDetails?.due_date }} </span>
</div>
<div>
    <span class="text-bold">Services: </span>
    <ol class="text-bold">
        <li *ngFor="let service of patientPackageDetails?.services_details">
            <div class="flex items-center gap-4">
                <span>Service Name: </span>
                <span class="font-400">{{ service?.service_name }}</span>
            </div>
            <div class="flex items-center gap-4">
                <span>Sessions: </span>
                <span class="font-400">{{ service?.doneCount || 0 }}/{{service?.frequency || 0}}</span>
            </div>
        </li>
    </ol>
</div>